import React from 'react';
import './styles/DesignerStyles.css';

class DesignerTextField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filled: this.props.filled,
    };
  }

  render() {
    return (
      <input
        disabled={this.props.disabled ? this.props.disabled : false}
        type={this.props.type ? this.props.type : 'text'}
        style={this.props.style}
        value={this.props.value}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}
        onFocus={this.props.onfocus}
        className="input"
        minLength={this.props.minLength}
        placeholder={
          this.props.placeholder ? this.props.placeholder : ''
        }></input>
    );
  }
}

export default DesignerTextField;
